import Vue from 'vue'
import Vuex from 'vuex'

// modules
import status from "./modules/status";
import user from "./modules/user";
import control from "./modules/control";
import data from "./modules/data";

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    status,
    user,
    control,
    data
  },
  state: {
  },
  mutations: {
  },
  actions: {
  },
})
